import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Store payment handler.
 * Handle store/cash payments (e.g., Kushki) by dispatching the store payment action
 * with purchaser and purchase data.
 */
registerHandler('store', {
  execute: async ({ onStorePaymentAttempt }) => {
    onStorePaymentAttempt();
  },
});
